import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Col, Form, FormGroup, FormControl, ControlLabel, Button, Checkbox } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

const FETCH_URL = "api/companies/admin"

class BedrijvenAdd extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.emptyForm = this.emptyForm.bind(this)
        this.state = this.getInitialState()
    }
    getInitialState = () => {
        return {
            data: {
                id: "0",
                name: "",
                city: "",
                zipCode: "",
                address: "",
                invoiceCity: "",
                invoiceZipCode: "",
                invoiceAddress: "",
                invoiceEmail: "",
                phone: "",
                website: "",
                searchWord: "",
                single: false,
                url: "",
                engineering: false,
                executive: false
            },
            errors: {}
        }
    }
    emptyForm() {
        this.setState(this.getInitialState())
        this.fileInput.value = ""
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    Api.print(response)
                    this.setState({ errors: response });
                }
                else {
                    alert("Bedrifj added")
                    this.emptyForm()
                    // TODO: Show message OK, redirect to the previous page or something like this
                }
            })
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    render() {
        let data = this.state.data
        let errors = this.state.errors
        return (
            <div>
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="BedrijfToevoegenNaam">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="name" value={data.name} onChange={this.handleChange} required />
                            {Api.showError(errors, "name")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenPlaats">
                        <Col componentClass={ControlLabel} sm={4}>
                            Plaats
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="city" value={data.city} onChange={this.handleChange} required />
                            {Api.showError(errors, "city")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenPostcode">
                        <Col componentClass={ControlLabel} sm={4}>
                            Postcode
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="zipCode" value={data.zipCode} onChange={this.handleChange} required />
                            {Api.showError(errors, "zipCode")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenBezoekadres">
                        <Col componentClass={ControlLabel} sm={4}>
                            Bezoekadres
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="address" value={data.address} onChange={this.handleChange} required />
                            {Api.showError(errors, "address")}
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="BedrijfToevoegenInvoicePlaats">
                        <Col componentClass={ControlLabel} sm={4}>
                            Plaats factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceCity" value={data.invoiceCity} onChange={this.handleChange} required />
                            {Api.showError(errors, "invoiceCity")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenInvoicePostcode">
                        <Col componentClass={ControlLabel} sm={4}>
                            Postcode factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceZipCode" value={data.invoiceZipCode} onChange={this.handleChange} required />
                            {Api.showError(errors, "invoiceZipCode")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenInvoiceadres">
                        <Col componentClass={ControlLabel} sm={4}>
                            Adres factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceAddress" value={data.invoiceAddress} onChange={this.handleChange} required />
                            {Api.showError(errors, "invoiceAddress")}
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="BedrijfToevoegenInvoiceemail">
                        <Col componentClass={ControlLabel} sm={4}>
                            E-mail factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceEmail" value={data.invoiceEmail} onChange={this.handleChange} required />
                            {Api.showError(errors, "invoiceEmail")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenTelefoon">
                        <Col componentClass={ControlLabel} sm={4}>
                            Telefoon
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="phone" value={data.phone} onChange={this.handleChange} required />
                            {Api.showError(errors, "phone")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenWebsite">
                        <Col componentClass={ControlLabel} sm={4}>
                            Website
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="website" value={data.website} onChange={this.handleChange} required />
                            {Api.showError(errors, "website")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkensearchWord">
                        <Col componentClass={ControlLabel} sm={4}>
                            Zoekwoord
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="searchWord" value={this.state.searchWord} onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenDocument">
                        <Col componentClass={ControlLabel} sm={4}>
                            Logo
                                </Col>
                        <Col sm={6}>
                            <FormControl type="File" inputRef={input => this.fileInput = input} />
                            {Api.showError(errors, "file")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenOpties">
                        <Col componentClass={ControlLabel} sm={4}>
                            Opties
                        </Col>
                        <Col sm={6}>
                            <Checkbox name="executive" checked={data.executive} onChange={this.handleChange}>Uitvoerend bedrijf</Checkbox>
                            <Checkbox name="engineering" checked={data.engineering} onChange={this.handleChange}>Ingenieursbedrijf</Checkbox>
                            <Checkbox name="single" checked={data.single} onChange={this.handleChange}>Zelfstandige</Checkbox>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col sm={12}>
                            <LinkContainer to="/admin/bedrijven"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                            <Button type="submit" className="pull-right">Toevoegen</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default BedrijvenAdd;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Bedrijven/Add.js